var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_706_4419)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.140167,
    width: 28,
    height: 28,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3594 8.64136L16.4032 9.00854C16.3 9.02104 16.2579 9.14604 16.3297 9.21948L17.1844 10.0742L14.786 12.4726C14.7627 12.4961 14.7497 12.5278 14.7497 12.5609C14.7497 12.594 14.7627 12.6257 14.786 12.6492L15.4907 13.3539C15.5391 13.4023 15.6188 13.4023 15.6672 13.3539L18.0672 10.9539L18.9219 11.8085C18.9384 11.825 18.9592 11.8365 18.9819 11.8417C19.0047 11.8469 19.0284 11.8456 19.0504 11.838C19.0724 11.8303 19.0918 11.8166 19.1064 11.7984C19.121 11.7802 19.1302 11.7583 19.1329 11.7351L19.4985 8.78042C19.5011 8.76155 19.4993 8.74234 19.4932 8.72429C19.4871 8.70624 19.4769 8.68983 19.4635 8.67637C19.45 8.6629 19.4336 8.65273 19.4156 8.64666C19.3975 8.64058 19.3783 8.63877 19.3594 8.64136V8.64136ZM12.5094 14.9257C12.4859 14.9025 12.4542 14.8894 12.4211 14.8894C12.3881 14.8894 12.3564 14.9025 12.3329 14.9257L9.93442 17.3257L9.07973 16.471C9.06324 16.4546 9.04244 16.4431 9.01972 16.4379C8.99699 16.4327 8.97326 16.434 8.95124 16.4416C8.92922 16.4493 8.90981 16.463 8.89523 16.4812C8.88065 16.4994 8.87149 16.5213 8.8688 16.5445L8.50161 19.4992C8.49223 19.5804 8.55942 19.6476 8.64067 19.6382L11.5969 19.271C11.7 19.2585 11.7422 19.1335 11.6704 19.0601L10.8157 18.2054L13.2157 15.8054C13.2641 15.757 13.2641 15.6773 13.2157 15.6289L12.5094 14.9257V14.9257Z",
    fill: "black",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.640167,
    width: 27,
    height: 27,
    rx: 7.5,
    stroke: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_706_4419",
    x: 0,
    y: 0.140167,
    width: 28,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.016 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_706_4419"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_706_4419",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expandIcon.679841b265c572001dcbc896142ae645.svg";
export { ForwardRef as ReactComponent };